import type { ReactNode } from 'react';
import navAdmin from '../features/drawer-menu/config/navAdmin';
import LAppOnline from '../../../app/layouts/LAppOnline';
import { Box, useMediaQuery, useTheme } from '@mui/material';

type LAdminProps = {
	children: ReactNode;
};

const LAdmin = (props: LAdminProps) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<LAppOnline
			navigationConfig={navAdmin}
			titleComponent={
				<Box
					sx={{
						color: '#FF4154',
						fontSize: '1.4rem',
						fontWeight: 'bold',
						fontFamily: 'Poppins',
					}}
				>
					{isMobile ? 'IP Tools' : 'IRP Admin tools'}
				</Box>
			}
		>
			{props.children}
		</LAppOnline>
	);
};

export default LAdmin;
